import { whatsappEnquiry } from '../data/site';
import { Icon } from './Primitives';

/**
 * Every navy piece leaves the pipeline centred on a square canvas at a fixed inset
 * (see centreOnNavySquare in scripts/build-assets.js), so one square plate suits
 * them all — and a row of cards shares a baseline without any per-shape juggling.
 *
 * The arch and circle masks this used to apply were dropped once the artwork was
 * squared: a dome over a wide collar clipped its top corners, and a tall arch left
 * a bare navy band beneath every piece.
 */
const GROUND = {
  silk: { ground: 'bg-cream-200', ring: 'ring-gold-600/15' },
  navy: { ground: 'bg-royal-800', ring: 'ring-gold-500/25' },
};

export default function ProductCard({ product, priority = false }) {
  const silk = product.shape === 'silk';
  const tone = silk ? GROUND.silk : GROUND.navy;
  // Silk flat-lays are full-bleed photographs; navy plates are cut-outs to letterbox.
  const fill = silk ? 'object-cover' : 'object-contain';

  return (
    <article className="group flex h-full flex-col">
      <div className="flex aspect-square items-center justify-center">
        <div
          className={`relative aspect-square w-full overflow-hidden ${tone.ground}
            ring-1 ring-inset ${tone.ring}`}
        >
          <img
            src={`/assets/products/${product.image}.webp`}
            alt={product.name}
            loading={priority ? 'eager' : 'lazy'}
            decoding="async"
            className={`h-full w-full ${fill} transition-transform duration-[1100ms]
              ease-luxe group-hover:scale-[1.06]`}
          />

          {/* Enquiry veil */}
          <div
            className="absolute inset-0 flex items-end justify-center bg-gradient-to-t
              from-royal-950/80 via-royal-950/10 to-transparent p-5 opacity-0
              transition-opacity duration-500 ease-luxe group-hover:opacity-100
              focus-within:opacity-100"
          >
            <a
              href={whatsappEnquiry(product.name)}
              target="_blank"
              rel="noreferrer noopener"
              className="btn-gold !px-5 !py-3 translate-y-2 transition-transform duration-500
                ease-luxe group-hover:translate-y-0"
            >
              Enquire
              <Icon.Arrow className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-4 text-center">
        <h3 className="font-display text-xl font-normal text-royal-900">{product.name}</h3>
        <p className="mx-auto mt-1.5 max-w-xs text-[13px] leading-relaxed text-royal-700/65">
          {product.blurb}
        </p>
      </div>
    </article>
  );
}
